import { render, staticRenderFns } from "./DashboardBudgetPermission.vue?vue&type=template&id=2498e058&"
import script from "./DashboardBudgetPermission.vue?vue&type=script&lang=js&"
export * from "./DashboardBudgetPermission.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBudgetPermission.vue?vue&type=style&index=0&id=2498e058&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports